/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubtaskReference
 */
export interface SubtaskReference {
    /**
     * 
     * @type {number}
     * @memberof SubtaskReference
     */
    id: number;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof SubtaskReference
     */
    readonly kwargs?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof SubtaskReference
     */
    readonly graphLayout?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly validationError?: string;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly trigger?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskReference
     */
    readonly noopDontSave?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskReference
     */
    readonly noConcurrency?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubtaskReference
     */
    readonly timeout?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskReference
     */
    readonly logVariable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly task?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly conditionVariable?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly conditionValue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskReference
     */
    readonly sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubtaskReference
     */
    readonly queue?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubtaskReference
     */
    readonly enqueueAtFront?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubtaskReference
     */
    readonly parent?: number;
    /**
     * 
     * @type {number}
     * @memberof SubtaskReference
     */
    readonly relativeTo?: number | null;
}

export function SubtaskReferenceFromJSON(json: any): SubtaskReference {
    return SubtaskReferenceFromJSONTyped(json, false);
}

export function SubtaskReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubtaskReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kwargs': !exists(json, 'kwargs') ? undefined : json['kwargs'],
        'graphLayout': !exists(json, 'graph_layout') ? undefined : json['graph_layout'],
        'validationError': !exists(json, 'validation_error') ? undefined : json['validation_error'],
        'trigger': !exists(json, 'trigger') ? undefined : json['trigger'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noopDontSave': !exists(json, 'noop_dont_save') ? undefined : json['noop_dont_save'],
        'noConcurrency': !exists(json, 'no_concurrency') ? undefined : json['no_concurrency'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'logVariable': !exists(json, 'log_variable') ? undefined : json['log_variable'],
        'task': !exists(json, 'task') ? undefined : json['task'],
        'conditionVariable': !exists(json, 'condition_variable') ? undefined : json['condition_variable'],
        'conditionValue': !exists(json, 'condition_value') ? undefined : json['condition_value'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'enqueueAtFront': !exists(json, 'enqueue_at_front') ? undefined : json['enqueue_at_front'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'relativeTo': !exists(json, 'relative_to') ? undefined : json['relative_to'],
    };
}

export function SubtaskReferenceToJSON(value?: SubtaskReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


